module.exports = __webpack_public_path__ + "static/media/lock-dialog.65dbfa5d.png";